import { authMutate } from '~/composables/http/authMutate';
import { useApiFetch } from '~/composables/http/useApiFetch';
import { isAPIErrorResponse } from '~/composables/useUtils';
import { createApiError } from '~/api/utils';
import type { Appearance, AppearancePatch } from '~/utils/appearance';

export interface UserSettings {
  appearance: Appearance;
}

export const fetchUserSettings = async (): Promise<UserSettings> => {
  const response = await useApiFetch<UserSettings>('me/settings');

  if (isAPIErrorResponse(response)) {
    throw createApiError('Les réglages n\'ont pas pu être lus', response.errors);
  }

  return response.data;
};

export const updateAppearanceSettings = async (patch: AppearancePatch): Promise<void> => {
  const response = await authMutate('me/settings/appearance', {
    method: 'PATCH',
    body: patch,
    silentError: true,
  });

  if (isAPIErrorResponse(response)) {
    throw createApiError('L\'apparence n\'a pas pu être enregistrée', response.errors);
  }
};
